// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-selection-wrapper {
  position: absolute;
  width: 160px;
  height: 160px;
  pointer-events: none;
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 0s 0.2s,
    opacity 0.2s ease-in;
}

.cesium-selection-wrapper-visible {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.2s ease-out;
}

.cesium-selection-wrapper svg {
  fill: #2e2;
  stroke: #000;
  stroke-width: 1.1px;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/SelectionIndicator/SelectionIndicator.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV;;wBAEsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".cesium-selection-wrapper {\n  position: absolute;\n  width: 160px;\n  height: 160px;\n  pointer-events: none;\n  visibility: hidden;\n  opacity: 0;\n  transition:\n    visibility 0s 0.2s,\n    opacity 0.2s ease-in;\n}\n\n.cesium-selection-wrapper-visible {\n  visibility: visible;\n  opacity: 1;\n  transition: opacity 0.2s ease-out;\n}\n\n.cesium-selection-wrapper svg {\n  fill: #2e2;\n  stroke: #000;\n  stroke-width: 1.1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
